import React from "react";
import { Plus } from "lucide-react";

const ServiceAddOns = () => {
  return (
    <div className="flex flex-col items-center justify-center text-center py-20">
      {/* Placeholder icon */}
      <div className="w-16 h-16 flex items-center justify-center mb-4">
        <div className="bg-gradient-to-br from-purple-400 to-blue-500 p-4 rounded-xl shadow-md">
          <Plus className="w-6 h-6 text-white" />
        </div>
      </div>

      {/* Title */}
      <h2 className="text-lg font-semibold mb-2">Service add-ons</h2>

      {/* Subtitle */}
      <p className="text-gray-500 text-sm max-w-md mb-6">
        Allow clients to add customizations and extras to their booking.{" "}
        <a href="#" className="text-purple-600 hover:underline">
          Learn more
        </a>
      </p>

      {/* Button */}
      <button className="px-4 py-2 rounded-md border border-gray-300 hover:bg-gray-100 text-sm font-medium">
        Add group
      </button>
    </div>
  );
};

export default ServiceAddOns;
